import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatOrderType, formatOrderedTime } from "./orderUtils";

export const downloadOrdersPDF = (orders, currencySymbol) => {
  const doc = new jsPDF();
  doc.text("Orders History", 14, 20);

  const columns = [
    "Order ID",
    "Order Type",
    "Ordered Time",
    "Phone",
    "Price",
    "Products",
    "Driver",
    "Status",
  ];

  const rows = orders.map((order) => {
    const products = (order.products || [])
      .filter((p) => p.active)
      .map(
        (p) => `${p.productTitle?.split(",")[0] || "Unnamed"} (x${p.quantity})`,
      )
      .join("\n");

    const driver =
      order.status === "pending"
        ? "Not Assigned"
        : order.assignedDriver?.name || order.driverName || "Not Assigned";

    return [
      order.orderId,
      formatOrderType(order.orderType),
      formatOrderedTime(order.createdAt),
      order.phoneNumber,
      `${currencySymbol}${Number(order.amount || 0).toFixed(2)}`,
      products,
      driver,
      order.status,
    ];
  });

  doc.autoTable({
    head: [columns],
    body: rows,
    startY: 30,
    styles: { fontSize: 10 },
  });

  doc.save("orders-history.pdf");
};
